import {
  Button,
  Image,
  Text,
  VStack,
  DarkMode,
  LightMode,
  readableColor,
  lighten,
  rem,
} from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import { type AlbumMetadata } from '../hooks/use-showcase-auth';

export const UserNotAllowedPage = ({ name, brandColor, customLogo, theme }: AlbumMetadata) => {
  const accentColor = brandColor ? `#${brandColor}` : null;
  const ColorModeWrapper = theme === 'dark' ? DarkMode : LightMode;

  const onClick = () => {
    location.reload();
  };

  return (
    <ColorModeWrapper>
      <VStack
        h="100vh"
        minH={rem(400)}
        w="100%"
        justifyContent="center"
        gap="200"
        bgColor="background"
        p="1rem"
      >
        {customLogo ? <Image alt={name} src={customLogo} width={rem(185)} /> : null}

        <Text variant="heading-xl" align="center" color="text-primary">
          {translate('This account doesn’t have access')}
        </Text>

        <Text variant="body-xl" color="text-primary" align="center">
          {translate('Try again, or contact your team’s admin for help.')}
        </Text>

        <Button
          size="lg"
          minW={rem(350)}
          {...(accentColor && {
            bgColor: accentColor,
            color: readableColor(accentColor),
            _hover: {
              bgColor: lighten(accentColor, 0.1),
            },
            _dark: {
              bgColor: accentColor,
              _hover: {
                bgColor: lighten(accentColor, 0.1),
              },
            },
          })}
          onClick={onClick}
        >
          {translate('Try again')}
        </Button>
      </VStack>
    </ColorModeWrapper>
  );
};
